import { render, staticRenderFns } from "./App.vue?vue&type=template&id=edf33340&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=edf33340&prod&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=edf33340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf33340",
  null
  
)

export default component.exports